@if (isInitialDataLoading) {
  <app-loading-spinner [fullPage]="true" message="Fetching user details..."></app-loading-spinner>
}

@if (!isInitialDataLoading) {
  <div>
    <nav
      [ngClass]="{
        'navbar navbar-expand-xl sticky-top navbar-custom navbar-light box-shadow flex-xl-nowrap p-0':
          isTabletMode && isAdminLoggedIn,
      }">
      @if (isAdminLoggedIn && isTabletMode) {
        <div class="px-3 d-flex flex-row justify-content-between w-100 align-items-center">
          <a class="navbar-brand d-flex align-items-center gap-2">
            <div class="logo-box bg-white p-1">
              <img src="./assets/logo.png" width="40" height="40" alt="Logo" style="object-fit: contain" />
            </div>
            <div class="logo-text">
              <h6 class="mb-0 fw-800 text-white letter-spacing-1">ENJOCHEM</h6>
              <small class="text-white opacity-50 fw-bold" style="font-size: 12px">ERP ADMIN</small>
            </div>
          </a>

          <button class="navbar-toggler navbar-light" type="button" (click)="toggleMainSidebar()">
            <span class="navbar-toggler-icon float-end"></span>
          </button>
        </div>
      }

      @if (isAdminLoggedIn) {
        <div
          class="sidebar"
          [class.sidebar-collapsed]="isSidebarCollapsed && !isTabletMode"
          [@slideInOut]="isTabletMode ? sidebarState : null">
          <app-sidebar
            (toggleSidebarEvent)="toggleMainSidebar()"
            (collapsedChange)="isSidebarCollapsed = $event"></app-sidebar>
        </div>

        <div class="sidebar-overlay" (click)="toggleMainSidebar()" [@displayInOut]="sidebarState"></div>
      }
    </nav>

    <div
      [ngClass]="{
        'sidebar-margin': isAdminLoggedIn && !isTabletMode,
        'sidebar-margin-collapsed': isAdminLoggedIn && !isTabletMode && isSidebarCollapsed,
      }">
      <router-outlet></router-outlet>
    </div>
  </div>
}

<ng-template #contentUpdateModal let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">Update Available</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <p>A new version of the app is available. Click "Update" to reload.</p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Close</button>
    <button class="btn btn-primary" (click)="updateApp()">Update</button>
  </div>
</ng-template>
